import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../config'

export async function setPeritajeStatusAddedCars(body) {
    const peritajeStatus = await axios.patch(
        `${REACT_APP_PERITADOR_API}/requests/presupuesto_reservado_new`,
    body
    )

    return peritajeStatus
}
